import React from 'react';

import { Flex } from '@chakra-ui/react';
import format from 'date-fns/format';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ArchivalComponent = (param) => {
  const archivalTime = param?.data?.archivalTime?.value;
  const formattedArchivalDate = archivalTime ? format(new Date(archivalTime), 'PP') : 'NA';

  return (
    <Flex w="100%" h="100%" alignItems="center">
      <TextBodyMedium>{formattedArchivalDate}</TextBodyMedium>
    </Flex>
  );
};

export default ArchivalComponent;
